module.exports = "img/22.a2f7f2.webp";